"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagListText = exports.TagListItem = exports.TagList = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _context = require("../../context");

var _layout = require("../../layout");

var _text = require("../../text");

var _utils = require("../../utils");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var TagList = (0, _context.styledWithTheme)('ul')(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    listStyleType: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0,
    margin: 0,
    marginBottom: "-".concat((0, _utils.px)(selectors.space('S100'))),
    '& > li': {
      marginBottom: (0, _utils.px)(selectors.space('S100'))
    }
  };
});
exports.TagList = TagList;
var TagListText = (0, _context.styledWithTheme)(_text.Text)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    color: selectors.color('neutral70'),
    padding: "6px 8px 2px 0"
  };
});
exports.TagListText = TagListText;
var TagListItem = ( /*#__PURE__*/0, _styledBase.default)(_layout.Row.withComponent('li', {
  target: "e168s66n1"
}), {
  target: "e168s66n0"
})(process.env.NODE_ENV === "production" ? {
  name: "4giot",
  styles: "overflow-x:hidden;padding-top:2px;padding-bottom:2px;display:block;padding-right:8px;"
} : {
  name: "4giot",
  styles: "overflow-x:hidden;padding-top:2px;padding-bottom:2px;display:block;padding-right:8px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2hlbHBlcnMvdGFnLWxpc3QvVGFnTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEIwRCIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9oZWxwZXJzL3RhZy1saXN0L1RhZ0xpc3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBzdHlsZWRXaXRoVGhlbWUgfSBmcm9tICcuLi8uLi9jb250ZXh0JztcbmltcG9ydCB7IFJvdyB9IGZyb20gJy4uLy4uL2xheW91dCc7XG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vdGV4dCc7XG5pbXBvcnQgeyBweCB9IGZyb20gJy4uLy4uL3V0aWxzJztcblxuZXhwb3J0IGNvbnN0IFRhZ0xpc3QgPSBzdHlsZWRXaXRoVGhlbWUoJ3VsJykoKHsgdGhlbWU6IHsgc2VsZWN0b3JzIH0gfSkgPT4gKHtcbiAgbGlzdFN0eWxlVHlwZTogJ25vbmUnLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIGZsZXhXcmFwOiAnd3JhcCcsXG4gIHBhZGRpbmc6IDAsXG4gIG1hcmdpbjogMCxcbiAgbWFyZ2luQm90dG9tOiBgLSR7cHgoc2VsZWN0b3JzLnNwYWNlKCdTMTAwJykpfWAsXG4gICcmID4gbGknOiB7XG4gICAgbWFyZ2luQm90dG9tOiBweChzZWxlY3RvcnMuc3BhY2UoJ1MxMDAnKSlcbiAgfVxufSkpO1xuXG5leHBvcnQgY29uc3QgVGFnTGlzdFRleHQgPSBzdHlsZWRXaXRoVGhlbWUoVGV4dCkoXG4gICh7IHRoZW1lOiB7IHNlbGVjdG9ycyB9IH0pID0+ICh7XG4gICAgY29sb3I6IHNlbGVjdG9ycy5jb2xvcignbmV1dHJhbDcwJyksXG4gICAgcGFkZGluZzogYDZweCA4cHggMnB4IDBgXG4gIH0pXG4pO1xuXG5leHBvcnQgY29uc3QgVGFnTGlzdEl0ZW0gPSBzdHlsZWQoUm93LndpdGhDb21wb25lbnQoJ2xpJykpYFxuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIHBhZGRpbmctdG9wOiAycHg7XG4gIHBhZGRpbmctYm90dG9tOiAycHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nLXJpZ2h0OiA4cHg7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.TagListItem = TagListItem;